'use client';

import SearchForm from '@/components/Search/SearchForm';
import Grid from '@/components/ui/Grid';
import CategorySelectField from './CategorySelectField';

const Filters = () => {
  return (
    <>
      <Grid.Col xs={12} md={6}>
        <CategorySelectField allLabel="All Categories" name="faqCategory" />
      </Grid.Col>
      <Grid.Col xs={12} md={6}>
        <SearchForm />
      </Grid.Col>
    </>
  );
};

export default Filters;
